<template>
  <div :class="type === 1 ? 'account' : 'appidclass'">
    <!-- <div class="dinwdw">
      <div class="name_boxr">会计主体编码：</div>
      <div style="display: flex">
        <el-input v-model="query.id" disabled placeholder="请输入内容" />
      </div>
    </div> -->
    <div class="dinwdw">
      <div class="name_boxr">会计主体编码：</div>
      <div>
        <el-button
          type="primary"
          size="mini"
          @click="chooseoperatetwoGroup(1)"
        >选择</el-button>
        <el-tag
          v-if="query.orgunit_code"
          style="margin-right: 10px; margin-bottom: 5px"
          closable
          :type="'success'"
          @close="rightclicktwoGroup(admincode.name, 1)"
        >
          {{ admincode.name }}
        </el-tag>
      </div>
    </div>
    <div class="dinwdw">
      <div class="name_boxr">部门编码：</div>
      <div>
        <el-button
          :disabled="query.orgunit_code == ''"
          type="primary"
          size="mini"
          @click="chooseoperatetwoGroup(2)"
        >选择</el-button>
        <el-tag
          v-if="query.dept_code"
          style="margin-right: 10px; margin-bottom: 5px"
          closable
          :type="'success'"
          @close="rightclicktwoGroup(admin.name, 2)"
        >
          {{ admin.name }}
        </el-tag>
      </div>
    </div>
    <div v-if="type == 2" class="dinwdw">
      <div class="name_boxr">公众号：</div>
      <el-button
        type="primary"
        size="mini"
        @click="chooseoperatetwo"
      >选择</el-button>
    </div>
    <div
      v-if="app_ids.length !== 0 && type == 2"
      style="height: 200px; overflow-y: auto"
    >
      <el-tag
        v-for="(itemr, index) in app_ids"
        :key="index"
        style="margin-right: 10px; margin-bottom: 5px"
        :closable="true"
        @close="rightclicktwo(itemr.app_id, index)"
      >
        {{ itemr.wechat_name }}
      </el-tag>
    </div>

    <el-dialog
      title="选择公众号"
      :visible.sync="dialogAccountIds"
      width="900px"
      :close-on-click-modal="false"
      append-to-body
    >
      <dialogAppid ref="appid" @bandarr="bandarrtwo" />
    </el-dialog>
    <el-dialog
      title="会计主体编码："
      :close-on-click-modal="false"
      :visible.sync="dialogorgunit_code"
      width="800px"
      append-to-body
    >
      <dialogCode ref="code" @bandarr="bandarrcode" />
    </el-dialog>
    <el-dialog
      title="部门编码："
      :close-on-click-modal="false"
      :visible.sync="dialogAdmin_id"
      width="800px"
      append-to-body
    >
      <wechatAuthAccount ref="admin" @bandarr="bandarrtwoGroup" />
    </el-dialog>
    <div style="float: right; margin-top: 20px">
      <el-button type="primary" size="mini" @click="submit">确定</el-button>
    </div>
  </div>
</template>

<script>
import wechatAuthAccount from './adqAuthAccount.vue'
import dialogCode from './dialogCode.vue'
import dialogAppid from './dialogAppid.vue'
// import accoutDetail from '../../WeChatAccount/components/accoutDetail.vue'
export default {
  components: { wechatAuthAccount, dialogCode, dialogAppid },
  data() {
    return {
      dialogAccountIds: false,
      dialogAdmin_id: false,
      dialogorgunit_code: false,
      query: {
        id: null,
        orgunit_code: '',
        dept_code: ''
      },
      admin: {},
      datas: {},
      admincode: {},
      app_ids: [],
      type: ''
    }
  },
  created() {},
  mounted() {},
  methods: {
    handleClose() {},
    submit() {
      if (this.query.orgunit_code === '') {
        this.$message.info('请选择会计主体编码')
        return
      }
      // eslint-disable-next-line eqeqeq
      if (this.query.dept_code === '') {
        this.$message.info('请选择部门编码')
        return
      }
      if (this.query.id === null) {
        this.$message.info('请选择id')
        return
      }
      let ids = true
      if (this.type === 2) {
        if (this.app_ids.length === 0) {
          ids = false
        }
        this.query.app_ids = this.app_ids.map((v) => v.app_id)
      }
      if (!ids) {
        this.$message.info('请选择公众号')
        return
      }
      this.$emit('callbackbacer', this.query)
      this.query = {
        orgunit_code: '',
        dept_code: ''
      }
      this.admin = {}
      this.app_ids = []
      this.admincode = {}
    },
    sendr(id, item, type) {
      console.log('id, item, type:', id, item, type)
      this.datas = item
      this.type = type
      if (id !== undefined) {
        this.query.id = id
      }
    },
    bandarrtwo(arr) {
      this.dialogAccountIds = false
      this.app_ids = []
      this.app_ids = arr
    },
    rightclicktwo(item, indexr, index) {
      console.log(item, indexr)
      this.query.orgunit_code.splice(indexr, 1)
    },
    rightclicktwoGroup(item, indexr) {
      console.log(item, indexr)
      if (indexr === 1) {
        this.admincode = {}
        this.query.orgunit_code = ''
      } else {
        this.admin = {}
        this.query.dept_code = ''
      }
    },
    chooseoperatetwo(index) {
      this.dialogAccountIds = true
      console.log(this.datas, ',==);')
      this.$nextTick(() => {
        this.$refs.appid.sendr(this.datas)
      })
    },
    chooseoperatetwoGroup(index) {
      if (index === 1) {
        this.dialogorgunit_code = true
        this.$nextTick(() => {
          this.$refs.code.sendr(this.datas.yonyou_orgunit_code)
        })
      } else {
        this.dialogAdmin_id = true
        this.$nextTick(() => {
          this.$refs.admin.sendr(this.admincode.name)
        })
      }
    },
    bandarrcode(arr) {
      console.log('arr:', arr)
      this.dialogorgunit_code = false
      const item = {
        name: arr.orgunit_name,
        id: arr.orgunit_code
      }
      this.query.orgunit_code = arr.orgunit_code

      this.admin = {}
      this.admincode = item
    },
    bandarrtwoGroup(arr) {
      this.dialogAdmin_id = false
      const item = {
        name: arr.dept_name,
        id: arr.dept_code
      }
      this.query.dept_code = arr.dept_code
      this.admin = {}
      this.admin = item
    }
  }
}
</script>

<style scoped>
/* @import url(); 引入css类 */
.dinwdw {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.name_boxr {
  color: rgb(169, 162, 151);
  font-size: 14px;
  width: 100px;
  text-align: right;
  flex-shrink: 0;
}
.account {
  height: 300px;
}
.appidclass {
  height: 500px;
}
</style>
